(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8972],{

/***/ 30853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ createReactComponent; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./node_modules/@tabler/icons-react/dist/esm/defaultAttributes.js
/**
 * @tabler/icons-react v2.22.0 - MIT
 */

var defaultAttributes = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};


//# sourceMappingURL=defaultAttributes.js.map

;// CONCATENATED MODULE: ./node_modules/@tabler/icons-react/dist/esm/createReactComponent.js
/**
 * @tabler/icons-react v2.22.0 - MIT
 */





var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var createReactComponent = (iconName, iconNamePascal, iconNode) => {
  const Component = (0,react.forwardRef)(
    (_a, ref) => {
      var _b = _a, { color = "currentColor", size = 24, stroke = 2, children } = _b, rest = __objRest(_b, ["color", "size", "stroke", "children"]);
      return (0,react.createElement)(
        "svg",
        __spreadValues(__spreadProps(__spreadValues({
          ref
        }, defaultAttributes), {
          width: size,
          height: size,
          stroke: color,
          strokeWidth: stroke,
          className: `tabler-icon tabler-icon-${iconName}`
        }), rest),
        [...iconNode.map(([tag, attrs]) => (0,react.createElement)(tag, attrs)), ...children || []]
      );
    }
  );
  Component.propTypes = {
    color: (prop_types_default()).string,
    size: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number]),
    stroke: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).number])
  };
  Component.displayName = `${iconNamePascal}`;
  return Component;
};


//# sourceMappingURL=createReactComponent.js.map


/***/ }),

/***/ 53865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconChevronRight; }
/* harmony export */ });
/* harmony import */ var _createReactComponent_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30853);
/**
 * @tabler/icons-react v2.22.0 - MIT
 */



var IconChevronRight = (0,_createReactComponent_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("chevron-right", "IconChevronRight", [
  ["path", { d: "M9 6l6 6l-6 6", key: "svg-0" }]
]);


//# sourceMappingURL=IconChevronRight.js.map


/***/ }),

/***/ 6480:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ Sidebar; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var shared_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83083);
/* harmony import */ var _sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10078);
/* harmony import */ var _sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5__);







const Sidebar = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const [activeMenu, setActiveMenu] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)();
    const { groups , menu  } = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(()=>{
        const propsMenu = props.menu.filter((it)=>it);
        if (!propsMenu.length) return {
            groups: null,
            menu: []
        };
        if ("menu" in propsMenu[0]) {
            const groups = propsMenu.map((it)=>({
                    ...it,
                    menu: it.menu.filter((it)=>it)
                }));
            const menu = groups.map((it)=>it.menu).flat();
            return {
                groups,
                menu
            };
        } else {
            return {
                groups: null,
                menu: propsMenu
            };
        }
    }, [
        props.menu
    ]);
    const checkActiveForDescktop = (menuItem)=>{
        if (router.asPath.startsWith(menuItem.additionalHref)) return true;
        switch(router.asPath){
            case menuItem.href:
                return true;
            case menuItem.additionalHref:
                return true;
            default:
                if (!menuItem.exact) return router.asPath.startsWith(menuItem.href);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        const activeLink = menu.find((elem)=>{
            if (elem.exact) return router.asPath === elem.additionalHref;
            return router.asPath.startsWith(elem.href);
        });
        setActiveMenu(activeLink);
    }, [
        menu,
        router
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().sidebar), props.sticky && (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().sticky), props.className),
        style: props.style,
        id: props.htmlId,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().sidebar_adaptive),
                children: activeMenu ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    href: props.mainHref,
                    className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().title),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}),
                        activeMenu.label,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().spacer)
                        })
                    ]
                }) : menu.map((it)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().adaptive_item),
                        href: it.exact ? it.additionalHref : it.href,
                        children: it.label
                    }, it.href))
            }),
            groups === null || groups === void 0 ? void 0 : groups.map((it, key)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
                    children: [
                        it.title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().group_title),
                            children: it.title
                        }),
                        it.menu.map((it)=>{
                            const active = checkActiveForDescktop(it);
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                href: it.href,
                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item), active && (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().active)),
                                children: it.label
                            }, it.href);
                        })
                    ]
                }, key)),
            !groups && menu.map((it)=>{
                const active = checkActiveForDescktop(it);
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    href: it.href,
                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item), active && (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().active)),
                    children: it.label
                }, it.href);
            })
        ]
    });
};
Sidebar.defaultProps = {
    sticky: true
};


/***/ }),

/***/ 47656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ WithSidebarContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var modules_layout_ui_container__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57711);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _with_sidebar_container_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11682);
/* harmony import */ var _with_sidebar_container_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_with_sidebar_container_module_scss__WEBPACK_IMPORTED_MODULE_5__);






const WithSidebarContainer = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const hideOnMobile = router.asPath === props.mainHref;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(modules_layout_ui_container__WEBPACK_IMPORTED_MODULE_4__/* .Container */ .W, {
        fullWidth: props.fullWidth,
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_with_sidebar_container_module_scss__WEBPACK_IMPORTED_MODULE_5___default().with_sidebar_container), props.className),
        style: props.style,
        htmlId: props.htmlId,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_with_sidebar_container_module_scss__WEBPACK_IMPORTED_MODULE_5___default().sidebar),
                children: props.sidebar
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_with_sidebar_container_module_scss__WEBPACK_IMPORTED_MODULE_5___default().main), hideOnMobile && (_with_sidebar_container_module_scss__WEBPACK_IMPORTED_MODULE_5___default().hide_on_mobile)),
                children: props.children
            })
        ]
    });
};
WithSidebarContainer.defaultProps = {};


/***/ }),

/***/ 43880:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ AvatarInput; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _avatar_input_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93347);
/* harmony import */ var _avatar_input_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_avatar_input_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var shared_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32636);
/* harmony import */ var _avatar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57233);






const AvatarInput = (props)=>{
    const image = shared_api__WEBPACK_IMPORTED_MODULE_3__/* .api.image.useImageImage */ .h.image.useImageImage(props.value);
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const inputRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const onClick = (e)=>{
        var _inputRef_current;
        e.preventDefault();
        (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.click();
    };
    const onChange = async (e)=>{
        if (loading) return;
        setLoading(true);
        try {
            var _e_target_files;
            const image = (_e_target_files = e.target.files) === null || _e_target_files === void 0 ? void 0 : _e_target_files[0];
            const { id  } = await shared_api__WEBPACK_IMPORTED_MODULE_3__/* .api.image.imageUploadImage */ .h.image.imageUploadImage(image);
            if (inputRef.current) inputRef.current.value = "";
            await props.onChange(id);
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_avatar_input_module_scss__WEBPACK_IMPORTED_MODULE_4___default().avatar_input), props.className),
        style: props.style,
        id: props.htmlId,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                onClick: onClick,
                tabIndex: props.tabIndex,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_avatar__WEBPACK_IMPORTED_MODULE_5__/* .Avatar */ .q, {
                    id: props.id,
                    name: props.name,
                    image: image.data,
                    size: 90,
                    className: (_avatar_input_module_scss__WEBPACK_IMPORTED_MODULE_4___default().avatar)
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                type: "file",
                onChangeCapture: onChange,
                ref: inputRef,
                className: (_avatar_input_module_scss__WEBPACK_IMPORTED_MODULE_4___default().input)
            })
        ]
    });
};
AvatarInput.defaultProps = {
    size: 78
};


/***/ }),

/***/ 73053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* binding */ Fieldset; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/ui/fieldset/error/fieldset-error.module.scss
var fieldset_error_module = __webpack_require__(98919);
var fieldset_error_module_default = /*#__PURE__*/__webpack_require__.n(fieldset_error_module);
;// CONCATENATED MODULE: ./src/shared/ui/fieldset/error/fieldset-error.tsx




const FieldsetError = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: classnames_default()((fieldset_error_module_default()).fieldset_error, props.className),
        style: props.style,
        id: props.htmlId,
        children: props.children
    });
};
FieldsetError.defaultProps = {};

// EXTERNAL MODULE: ./src/shared/ui/fieldset/content/fieldset-content.module.scss
var fieldset_content_module = __webpack_require__(50170);
var fieldset_content_module_default = /*#__PURE__*/__webpack_require__.n(fieldset_content_module);
;// CONCATENATED MODULE: ./src/shared/ui/fieldset/content/fieldset-content.tsx




const FieldsetContent = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((fieldset_content_module_default()).fieldset_content, props.className),
        style: props.style,
        id: props.htmlId,
        children: props.children
    });
};
FieldsetContent.defaultProps = {};

// EXTERNAL MODULE: ./src/shared/ui/fieldset/fieldset.module.scss
var fieldset_module = __webpack_require__(55290);
var fieldset_module_default = /*#__PURE__*/__webpack_require__.n(fieldset_module);
// EXTERNAL MODULE: ./src/shared/ui/fieldset/footer/fieldset-footer.module.scss
var fieldset_footer_module = __webpack_require__(4266);
var fieldset_footer_module_default = /*#__PURE__*/__webpack_require__.n(fieldset_footer_module);
// EXTERNAL MODULE: ./src/shared/ui/fieldset/footer/status/fieldset-footer-status.module.scss
var fieldset_footer_status_module = __webpack_require__(618);
var fieldset_footer_status_module_default = /*#__PURE__*/__webpack_require__.n(fieldset_footer_status_module);
;// CONCATENATED MODULE: ./src/shared/ui/fieldset/footer/status/fieldset-footer-status.tsx




const FieldsetFooterStatus = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((fieldset_footer_status_module_default()).fieldset_footer_status, props.className),
        style: props.style,
        id: props.htmlId,
        children: props.children
    });
};
FieldsetFooterStatus.defaultProps = {};

// EXTERNAL MODULE: ./src/shared/ui/fieldset/footer/actions/fieldset-footer-actions.module.scss
var fieldset_footer_actions_module = __webpack_require__(70148);
var fieldset_footer_actions_module_default = /*#__PURE__*/__webpack_require__.n(fieldset_footer_actions_module);
;// CONCATENATED MODULE: ./src/shared/ui/fieldset/footer/actions/fieldset-footer-actions.tsx




const FieldsetFooterActions = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((fieldset_footer_actions_module_default()).fieldset_footer_actions, props.className),
        style: props.style,
        id: props.htmlId,
        children: props.children
    });
};
FieldsetFooterActions.defaultProps = {};

;// CONCATENATED MODULE: ./src/shared/ui/fieldset/footer/fieldset-footer.tsx






const FieldsetFooter = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((fieldset_footer_module_default()).fieldset_footer, props.className),
        style: props.style,
        id: props.htmlId,
        children: props.children
    });
};
FieldsetFooter.Status = FieldsetFooterStatus;
FieldsetFooter.Actions = FieldsetFooterActions;
FieldsetFooter.defaultProps = {};

// EXTERNAL MODULE: ./src/shared/ui/fieldset/header/fieldset-header.module.scss
var fieldset_header_module = __webpack_require__(16549);
var fieldset_header_module_default = /*#__PURE__*/__webpack_require__.n(fieldset_header_module);
;// CONCATENATED MODULE: ./src/shared/ui/fieldset/header/fieldset-header.tsx




const FieldsetHeader = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((fieldset_header_module_default()).fieldset_header, props.className),
        style: props.style,
        id: props.htmlId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (fieldset_header_module_default()).title,
                children: props.children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (fieldset_header_module_default()).actions,
                children: props.actions
            })
        ]
    });
};
FieldsetHeader.defaultProps = {};

// EXTERNAL MODULE: ./src/shared/ui/fieldset/subtitle/fieldset-subtitle.module.scss
var fieldset_subtitle_module = __webpack_require__(24311);
var fieldset_subtitle_module_default = /*#__PURE__*/__webpack_require__.n(fieldset_subtitle_module);
;// CONCATENATED MODULE: ./src/shared/ui/fieldset/subtitle/fieldset-subtitle.tsx




const FieldsetSubtitle = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((fieldset_subtitle_module_default()).fieldset_subtitle, props.className),
        style: props.style,
        id: props.htmlId,
        children: props.children
    });
};
FieldsetSubtitle.defaultProps = {};

// EXTERNAL MODULE: ./src/shared/ui/fieldset/title/fieldset-title.module.scss
var fieldset_title_module = __webpack_require__(37125);
var fieldset_title_module_default = /*#__PURE__*/__webpack_require__.n(fieldset_title_module);
;// CONCATENATED MODULE: ./src/shared/ui/fieldset/title/fieldset-title.tsx




const FieldsetTitle = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((fieldset_title_module_default()).fieldset_title, props.className),
        style: props.style,
        id: props.htmlId,
        children: props.children
    });
};
FieldsetTitle.defaultProps = {};

;// CONCATENATED MODULE: ./src/shared/ui/fieldset/fieldset.tsx










const Fieldset = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((fieldset_module_default()).fieldset, props.disabled && (fieldset_module_default()).disabled, props.type === "error" && (fieldset_module_default()).error, props.className),
        style: props.style,
        id: props.htmlId,
        children: props.children
    });
};
Fieldset.Header = FieldsetHeader;
Fieldset.Content = FieldsetContent;
Fieldset.Footer = FieldsetFooter;
Fieldset.Title = FieldsetTitle;
Fieldset.Subtitle = FieldsetSubtitle;
Fieldset.Error = FieldsetError;
Fieldset.defaultProps = {};


/***/ }),

/***/ 10078:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"sidebar_sidebar__sYHpc","sticky":"sidebar_sticky__tqhuP","sidebar_adaptive":"sidebar_sidebar_adaptive__It1u0","adaptive_item":"sidebar_adaptive_item__UCFjh","title":"sidebar_title__41UVT","item":"sidebar_item__3MhXw","active":"sidebar_active__ezSut","group_title":"sidebar_group_title__gZU9o","spacer":"sidebar_spacer__WlMwR"};

/***/ }),

/***/ 11682:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"with_sidebar_container":"with-sidebar-container_with_sidebar_container__nlbUn","sidebar":"with-sidebar-container_sidebar__s3m9i","main":"with-sidebar-container_main__UyQ8Z","hide_on_mobile":"with-sidebar-container_hide_on_mobile__F4a_D"};

/***/ }),

/***/ 93347:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"avatar_input":"avatar-input_avatar_input__od6Ss","avatar":"avatar-input_avatar__G7p_p","input":"avatar-input_input__LjlTg"};

/***/ }),

/***/ 50170:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fieldset_content":"fieldset-content_fieldset_content__dddAu"};

/***/ }),

/***/ 98919:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fieldset_error":"fieldset-error_fieldset_error__3N6pd"};

/***/ }),

/***/ 55290:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"fieldset_fieldset__JO7vs","error":"fieldset_error__lCQ4p","disabled":"fieldset_disabled__PhBDK"};

/***/ }),

/***/ 70148:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fieldset_footer_actions":"fieldset-footer-actions_fieldset_footer_actions__JTZ2Z"};

/***/ }),

/***/ 4266:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fieldset_footer":"fieldset-footer_fieldset_footer__qgT8K"};

/***/ }),

/***/ 618:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fieldset_footer_status":"fieldset-footer-status_fieldset_footer_status__baQ31"};

/***/ }),

/***/ 16549:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fieldset_header":"fieldset-header_fieldset_header__v_CuI","actions":"fieldset-header_actions__Qwk1H"};

/***/ }),

/***/ 24311:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fieldset_subtitle":"fieldset-subtitle_fieldset_subtitle__oWOHM"};

/***/ }),

/***/ 37125:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fieldset_title":"fieldset-title_fieldset_title__VW1IC"};

/***/ }),

/***/ 92703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 69921:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=Symbol.for("react.element"),c=Symbol.for("react.portal"),d=Symbol.for("react.fragment"),e=Symbol.for("react.strict_mode"),f=Symbol.for("react.profiler"),g=Symbol.for("react.provider"),h=Symbol.for("react.context"),k=Symbol.for("react.server_context"),l=Symbol.for("react.forward_ref"),m=Symbol.for("react.suspense"),n=Symbol.for("react.suspense_list"),p=Symbol.for("react.memo"),q=Symbol.for("react.lazy"),t=Symbol.for("react.offscreen"),u;u=Symbol.for("react.module.reference");
function v(a){if("object"===typeof a&&null!==a){var r=a.$$typeof;switch(r){case b:switch(a=a.type,a){case d:case f:case e:case m:case n:return a;default:switch(a=a&&a.$$typeof,a){case k:case h:case l:case q:case p:case g:return a;default:return r}}case c:return r}}}__webpack_unused_export__=h;__webpack_unused_export__=g;__webpack_unused_export__=b;__webpack_unused_export__=l;__webpack_unused_export__=d;__webpack_unused_export__=q;__webpack_unused_export__=p;__webpack_unused_export__=c;__webpack_unused_export__=f;__webpack_unused_export__=e;__webpack_unused_export__=m;
__webpack_unused_export__=n;__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(a){return v(a)===h};__webpack_unused_export__=function(a){return v(a)===g};__webpack_unused_export__=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};__webpack_unused_export__=function(a){return v(a)===l};exports.isFragment=function(a){return v(a)===d};__webpack_unused_export__=function(a){return v(a)===q};__webpack_unused_export__=function(a){return v(a)===p};
__webpack_unused_export__=function(a){return v(a)===c};__webpack_unused_export__=function(a){return v(a)===f};__webpack_unused_export__=function(a){return v(a)===e};__webpack_unused_export__=function(a){return v(a)===m};__webpack_unused_export__=function(a){return v(a)===n};
__webpack_unused_export__=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===e||a===m||a===n||a===t||"object"===typeof a&&null!==a&&(a.$$typeof===q||a.$$typeof===p||a.$$typeof===g||a.$$typeof===h||a.$$typeof===l||a.$$typeof===u||void 0!==a.getModuleId)?!0:!1};__webpack_unused_export__=v;


/***/ }),

/***/ 59864:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(69921);
} else {}


/***/ })

}]);